import { render, staticRenderFns } from "./TreatmentRate.vue?vue&type=template&id=66ebf248&scoped=true&lang=pug&"
import script from "./TreatmentRate.vue?vue&type=script&lang=js&"
export * from "./TreatmentRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebf248",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
